import { TAPIQueryKeys } from 'common/api-calls/common-api-types.ts';
import { userSpecificApiKey } from 'src/common/utils/apicall/api-key';
import {
  APICancelDeliveryRequest,
  APIDeliveryRequestCount,
  APIDeliveryRequestDetail,
  APIDeliveryRequestsList,
} from 'common/api-calls/delivery-request/visibility/types.ts';
import { Optional } from 'common/types.ts';

const featureApiKey = userSpecificApiKey('delivery-request-visibility');

type Keys = {
  all: never;
  list: Omit<Optional<APIDeliveryRequestsList['queries'], 'page'>, 'statuses'>;
  detail: APIDeliveryRequestDetail['params'];
  cancel: APICancelDeliveryRequest['params'];
  count: APIDeliveryRequestCount['params'];
};

// todo: move to utils
function getKeys<k extends keyof Keys>(key: keyof Keys) {
  return (params?: Keys[k]) => (params ? [featureApiKey, key, ...Object.values(params)] : [featureApiKey, key]);
}

export const apiKeyDeliveryRequestVisibility: TAPIQueryKeys<Keys> = {
  all: () => [featureApiKey],
  list: getKeys('list'),
  detail: getKeys('detail'),
  cancel: getKeys('cancel'),
  count: getKeys('count'),
};
